export const buildStyles = (theme, screenSize, isRTL = false, getStatusColor, getUrgencyColor) => ({
    pageContainer: {
        direction: isRTL ? "rtl" : "ltr",
    },

    container: {
        margin: "0 auto",
    },
    card1: {
        background: theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        WebkitBackdropFilter: theme === "dark" ? "blur(25px) saturate(180%)" : "blur(10px)",
        border: theme === "dark" ? "1px solid rgba(255,255,255,0.15)" : "1px solid rgba(0,0,0,0.05)",
        borderRadius: screenSize.isMobile ? "12px" : screenSize.isTablet ? "20px" : "28px",
        padding: screenSize.isMobile ? "16px" : screenSize.isTablet ? "20px" : "28px",
        boxShadow: "none",
        marginBottom: screenSize.isMobile ? "16px" : screenSize.isTablet ? "20px" : "24px",
        transition: "all 0.3s ease",
        cursor: "pointer",
        direction: isRTL ? "rtl" : "ltr",
    },
    pageHeader: {
        background:
            theme === "dark"
                ? "linear-gradient(145deg, rgba(30, 41, 59, 0.8) 0%, rgba(30, 41, 59, 0.6) 100%)"
                : "linear-gradient(145deg, #ffffff 0%, #fafafa 100%)",
        borderRadius: "32px",
        padding: screenSize.isMobile ? "48px 32px" : "64px 56px",
        marginBottom: "48px",
        border:
            theme === "dark"
                ? "2px solid rgba(231, 231, 237, 0.4)"
                : "2px solid rgba(231, 231, 237, 0.4)",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
    },
    profileHeader: {
        background: theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        padding: screenSize.isMobile ? "16px" : screenSize.isTablet ? "20px" : "24px",
        borderRadius: screenSize.isMobile ? "1rem" : screenSize.isTablet ? "1.25rem" : "1rem",
        transition: "all 0.3s ease",
        boxShadow: "none",
        WebkitBackdropFilter: theme === "dark" ? "blur(25px) saturate(180%)" : "blur(10px)",
        border: theme === "dark" ? "1px solid rgba(255,255,255,0.15)" : "1px solid rgba(0,0,0,0.05)",
        cursor: "pointer",
        marginBottom: screenSize.isMobile ? "16px" : screenSize.isTablet ? "20px" : "24px",
    },

    pageTitle: {
        color: theme === "dark" ? "white" : "#1a1a1a",
        fontWeight: "700",
        textShadow: "none",
        lineHeight: "1.2",
        margin: 0,
    },

    quickActionsGrid: {
        display: "grid",
        gridTemplateColumns: screenSize.isMobile ? "1fr" : "repeat(2, 1fr)",
        gap: "32px",
        marginBottom: "48px",
    },

    quickActionCard: {
        background:
            theme === "dark"
                ? "rgba(255,255,255,0.05)"
                : "rgba(255, 255, 255, 0.81)",
        backdropFilter: "blur(30px)",
        WebkitBackdropFilter: "blur(30px)",
        border:
            theme === "dark"
                ? "2px solid rgba(255,255,255,0.15)"
                : "2px solid rgba(0,0,0,0.1)",
        borderRadius: "28px",
        padding: screenSize.isMobile ? "32px 28px" : "40px 36px",
        cursor: "pointer",
        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        position: "relative",
        overflow: "hidden",
        boxShadow: "none",
    },

    quickActionIcon: {
        width: "80px",
        height: "80px",
        background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
        borderRadius: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "24px",
        boxShadow: "none",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
    },

    quickActionTitle: {
        color: theme === "dark" ? "#fff" : "#1e293b",
        fontSize: screenSize.isMobile ? "22px" : "28px",
        fontWeight: "800",
        margin: "0 0 16px 0",
        lineHeight: 1.2,
    },

    quickActionDescription: {
        color:
            theme === "dark"
                ? "rgba(255, 255, 255, 0.8)"
                : "rgba(30, 41, 59, 0.75)",
        fontSize: "16px",
        lineHeight: 1.7,
        margin: "0 0 24px 0",
    },

    quickActionArrow: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        color: "#3b82f6",
        fontWeight: "700",
        fontSize: "15px",
        marginTop: "auto",
    },

    card: {
        background:
            theme === "dark"
                ? "linear-gradient(145deg, rgba(30, 41, 59, 0.8) 0%, rgba(30, 41, 59, 0.6) 100%)"
                : "linear-gradient(145deg, #ffffff 0%, #fafafa 100%)",
        backdropFilter: "blur(30px)",
        WebkitBackdropFilter: "blur(30px)",
        border:
            theme === "dark"
                ? "2px solid rgba(255, 255, 255, 0.15)"
                : "2px solid rgba(0, 0, 0, 0.08)",
        borderRadius: "28px",
        padding: screenSize.isMobile ? "28px" : "40px",
        marginBottom: "32px",
        transition: "all 0.3s ease",
    },

    cardTitle: {
        fontSize: screenSize.isMobile ? "22px" : "28px",
        fontWeight: "800",
        color: theme === "dark" ? "#fff" : "#1e293b",
        margin: "0 0 28px 0",
        display: "flex",
        alignItems: "center",
        gap: "14px",
    },

    statsGrid: {
        display: "grid",
        gridTemplateColumns: screenSize.isMobile
            ? "1fr"
            : screenSize.isTablet
                ? "repeat(2, 1fr)"
                : "repeat(4, 1fr)",
        gap: "24px",
        marginBottom: "40px",
    },

    statCard: {
        background:
            theme === "dark"
                ? "linear-gradient(145deg, rgba(59, 130, 246, 0.15) 0%, rgba(37, 99, 235, 0.1) 100%)"
                : "linear-gradient(145deg, rgba(59, 130, 246, 0.08) 0%, rgba(59, 130, 246, 0.05) 100%)",
        border:
            theme === "dark"
                ? "2px solid rgba(255, 255, 255, 0.3)"
                : "2px solid rgba(59, 130, 246, 0.2)",
        borderRadius: "20px",
        padding: "28px",
        textAlign: "center",
        transition: "all 0.3s ease",
        // boxShadow removed for flat appearance
    },

    statValue: {
        fontSize: screenSize.isMobile ? "28px" : "36px",
        fontWeight: "900",
        marginBottom: "10px",
        background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
    },

    statLabel: {
        fontSize: "15px",
        color:
            theme === "dark"
                ? "rgba(255, 255, 255, 0.75)"
                : "rgba(30, 41, 59, 0.75)",
        fontWeight: "600",
    },

    toolbar: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "20px",
        flexWrap: "wrap",
        //marginBottom: "32px",
    },

    searchContainer: {
        position: "relative",
        flex: screenSize.isMobile ? "1 1 100%" : "1 1 450px",
    },

    searchInput: {
        width: "100%",
        padding: isRTL ? "16px 52px 16px 24px" : "16px 24px 16px 52px",
        background:
            theme === "dark"
                ? "rgba(255, 255, 255, 0.08)"
                : "rgba(255, 255, 255, 0.95)",
        border:
            theme === "dark"
                ? "2px solid rgba(255, 255, 255, 0.15)"
                : "2px solid rgba(0, 0, 0, 0.1)",
        borderRadius: "16px",
        fontSize: "16px",
        color: theme === "dark" ? "#fff" : "#1e293b",
        outline: "none",
        transition: "all 0.3s ease",
        boxShadow: "none",
    },

    searchIcon: {
        position: "absolute",
        [isRTL ? "right" : "left"]: "18px",
        top: "50%",
        transform: "translateY(-50%)",
        color:
            theme === "dark" ? "rgba(255, 255, 255, 0.6)" : "rgba(30, 41, 59, 0.6)",
    },

    primaryButton: {
        background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
        color: "#fff",
        border: "none",
        padding: "14px 28px",
        borderRadius: "14px",
        fontSize: "16px",
        fontWeight: "700",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        transition: "all 0.3s ease",
    },

    secondaryButton: {
        background:
            theme === "dark" ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.06)",
        color: theme === "dark" ? "#fff" : "#1e293b",
        border:
            theme === "dark"
                ? "2px solid rgba(255, 255, 255, 0.2)"
                : "2px solid rgba(0, 0, 0, 0.12)",
        padding: "14px 28px",
        borderRadius: "14px",
        fontSize: "16px",
        fontWeight: "700",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        transition: "all 0.3s ease",
    },

    categoryFilter: {
        display: "flex",
        gap: "16px",
        flexWrap: "wrap",
        padding: "8px",
    },

    categoryItem: (isActive) => ({
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "12px 22px",
        borderRadius: "14px",
        fontSize: "15px",
        fontWeight: "700",
        cursor: "pointer",
        transition: "all 0.3s ease",
        background: isActive
            ? "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)"
            : theme === "dark"
                ? "rgba(255, 255, 255, 0.08)"
                : "rgba(0, 0, 0, 0.04)",
        color: isActive
            ? "#fff"
            : theme === "dark"
                ? "rgba(255, 255, 255, 0.85)"
                : "rgba(30, 41, 59, 0.85)",
        border: isActive
            ? "none"
            : theme === "dark"
                ? "2px solid rgba(255, 255, 255, 0.12)"
                : "2px solid rgba(0, 0, 0, 0.08)",
    }),

    categoryCount: {
        background:
            theme === "dark"
                ? "linear-gradient(145deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.05) 100%)"
                : "linear-gradient(145deg, #3b82f6 0%, #3b82f6 100%)",
        color:
            theme === "dark"
                ? "linear-gradient(145deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.05) 100%)"
                : "linear-gradient(145deg, #ffffff 0%, #fafafa 100%)",
        padding: "4px 10px",
        borderRadius: "10px",
        fontSize: "13px",
        fontWeight: "800",
    },

    documentGrid: {
        display: "grid",
        gridTemplateColumns: screenSize.isMobile
            ? "1fr"
            : screenSize.isTablet
                ? "repeat(2, 1fr)"
                : "repeat(auto-fill, minmax(320px, 1fr))",
        gap: "24px",
    },

    documentCard: (isSelected) => ({
        background:
            theme === "dark"
                ? "linear-gradient(145deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.05) 100%)"
                : "linear-gradient(145deg, #ffffff 0%, #fafafa 100%)",
        border: `3px solid ${isSelected
            ? "#3b82f6"
            : theme === "dark"
                ? "rgba(255, 255, 255, 0.12)"
                : "rgba(0, 0, 0, 0.08)"
            }`,
        borderRadius: "20px",
        padding: "28px",
        cursor: "pointer",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    }),

    fileIconContainer: (color) => ({
        width: "84px",
        height: "84px",
        background: `linear-gradient(135deg, ${color}25 0%, ${color}15 100%)`,
        borderRadius: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "20px",
        margin: "0 auto 20px",
    }),

    documentName: {
        fontSize: "18px",
        fontWeight: "800",
        color: theme === "dark" ? "#fff" : "#1e293b",
        margin: "0 0 12px 0",
        textAlign: "center",
        lineHeight: 1.3,
    },

    documentMeta: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        fontSize: "14px",
        color:
            theme === "dark"
                ? "rgba(255, 255, 255, 0.65)"
                : "rgba(30, 41, 59, 0.65)",
        marginBottom: "16px",
    },

    statusBadge: (status) => ({
        padding: "8px 16px",
        background: `${getStatusColor(status)}25`,
        color: getStatusColor(status),
        borderRadius: "10px",
        fontSize: "13px",
        fontWeight: "800",
        textTransform: "capitalize",
        display: "inline-block",
    }),

    documentDate: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        fontSize: "13px",
        color:
            theme === "dark"
                ? "rgba(255, 255, 255, 0.55)"
                : "rgba(30, 41, 59, 0.55)",
        marginTop: "16px",
    },

    modalOverlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.8)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: "24px",
        animation: "fadeIn 0.3s ease",
    },

    modalContent: {
        background:
            theme === "dark"
                ? "linear-gradient(145deg, rgba(30, 41, 59, 0.98) 0%, rgba(30, 41, 59, 0.95) 100%)"
                : "linear-gradient(145deg, #ffffff 0%, #fafafa 100%)",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        WebkitOverflowScrolling: "touch",
        backdropFilter: "blur(40px)",
        WebkitBackdropFilter: "blur(40px)",
        border:
            theme === "dark"
                ? "2px solid rgba(255, 255, 255, 0.15)"
                : "2px solid rgba(0, 0, 0, 0.1)",
        borderRadius: "32px",
        padding: screenSize.isMobile ? "32px" : "48px",
        width: "100%",
        maxWidth: screenSize.isMobile ? "95%" : "600px",
        maxHeight: "90vh",
        overflowY: "auto",
        animation: "slideUp 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    },

    modalHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "32px",
        paddingBottom: "24px",
        borderBottom:
            theme === "dark"
                ? "2px solid rgba(255, 255, 255, 0.12)"
                : "2px solid rgba(0, 0, 0, 0.1)",
    },

    modalTitle: {
        fontSize: screenSize.isMobile ? "24px" : "30px",
        fontWeight: "900",
        color: theme === "dark" ? "#fff" : "#1e293b",
        margin: 0,
    },

    closeButton: {
        background: "none",
        border: "none",
        color: theme === "dark" ? "#fff" : "#1e293b",
        cursor: "pointer",
        padding: "10px",
        borderRadius: "12px",
        transition: "all 0.2s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    formGroup: {
        marginBottom: "28px",
    },

    formLabel: {
        display: "block",
        marginBottom: "12px",
        fontSize: "15px",
        fontWeight: "700",
        color: theme === "dark" ? "#fff" : "#1e293b",
        textAlign: isRTL ? "right" : "left",
    },

    formInput: {
        width: "100%",
        padding: "16px 20px",
        background:
            theme === "dark"
                ? "rgba(255, 255, 255, 0.08)"
                : "rgba(255, 255, 255, 0.95)",
        border:
            theme === "dark"
                ? "2px solid rgba(255, 255, 255, 0.15)"
                : "2px solid rgba(0, 0, 0, 0.1)",
        borderRadius: "14px",
        fontSize: "16px",
        color: theme === "dark" ? "#fff" : "#1e293b",
        outline: "none",
        transition: "all 0.3s ease",
        
    },

    formTextarea: {
        width: "100%",
        padding: "16px 20px",
        background:
            theme === "dark"
                ? "rgba(255, 255, 255, 0.08)"
                : "rgba(255, 255, 255, 0.95)",
        border:
            theme === "dark"
                ? "2px solid rgba(255, 255, 255, 0.15)"
                : "2px solid rgba(0, 0, 0, 0.1)",
        borderRadius: "14px",
        fontSize: "16px",
        color: theme === "dark" ? "#fff" : "#1e293b",
        outline: "none",
        transition: "all 0.3s ease",
        
        minHeight: "140px",
        resize: "vertical",
    },

    formSelect: {
        width: "100%",
        padding: "16px 20px",
        background:
            theme === "dark"
                ? "rgba(255, 255, 255, 0.08)"
                : "rgba(255, 255, 255, 0.95)",
        border:
            theme === "dark"
                ? "2px solid rgba(255, 255, 255, 0.15)"
                : "2px solid rgba(0, 0, 0, 0.1)",
        borderRadius: "14px",
        fontSize: "16px",
        color: theme === "dark" ? "#fff" : "#1e293b",
        outline: "none",
        transition: "all 0.3s ease",
        
        cursor: "pointer",
    },

    uploadArea: {
        border: `3px dashed ${theme === "dark" ? "rgba(99, 102, 241, 0.5)" : "rgba(59, 130, 246, 0.5)"
            }`,
        borderRadius: "20px",
        padding: "56px 40px",
        textAlign: "center",
        background:
            theme === "dark"
                ? "rgba(99, 102, 241, 0.08)"
                : "rgba(59, 130, 246, 0.05)",
        marginBottom: "28px",
        transition: "all 0.3s ease",
        cursor: "pointer",
    },

    uploadIcon: {
        marginBottom: "24px",
        opacity: 0.85,
    },

    uploadTitle: {
        fontSize: "20px",
        fontWeight: "800",
        color: theme === "dark" ? "#fff" : "#1e293b",
        margin: "0 0 10px 0",
    },

    uploadSubtitle: {
        fontSize: "15px",
        color:
            theme === "dark" ? "rgba(255, 255, 255, 0.7)" : "rgba(30, 41, 59, 0.7)",
        margin: "0 0 28px 0",
    },

    modalActions: {
        display: "flex",
        gap: "16px",
        justifyContent: "flex-end",
        marginTop: "36px",
        paddingTop: "28px",
        borderTop:
            theme === "dark"
                ? "2px solid rgba(255, 255, 255, 0.12)"
                : "2px solid rgba(0, 0, 0, 0.1)",
        flexWrap: "wrap",
    },

    emptyState: {
        textAlign: "center",
        padding: "80px 40px",
        color:
            theme === "dark" ? "rgba(255, 255, 255, 0.6)" : "rgba(30, 41, 59, 0.6)",
    },

    emptyStateIcon: {
        marginBottom: "24px",
        opacity: 0.6,
    },

    emptyStateText: {
        fontSize: "18px",
        fontWeight: "600",
        lineHeight: 1.6,
    },

    progressBarContainer: {
        background:
            theme === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.06)",
        height: "16px",
        borderRadius: "10px",
        overflow: "hidden",
        marginBottom: "16px",
        position: "relative",
    },

    progressBar: (percentage) => ({
        height: "100%",
        width: `${percentage}%`,
        background: "linear-gradient(90deg, #3b82f6 0%, #2563eb 100%)",
        borderRadius: "10px",
        transition: "width 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
    }),

    progressText: {
        display: "flex",
        justifyContent: "space-between",
        fontSize: "14px",
        color:
            theme === "dark" ? "rgba(255, 255, 255, 0.7)" : "rgba(30, 41, 59, 0.7)",
        fontWeight: "600",
    },

    viewModeButtons: {
        display: "flex",
        gap: "10px",
        background:
            theme === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.04)",
        padding: "6px",
        borderRadius: "14px",
    },

    viewModeButton: (isActive) => ({
        padding: "12px 20px",
        background: isActive
            ? "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)"
            : "transparent",
        color: isActive
            ? "#fff"
            : theme === "dark"
                ? "rgba(255, 255, 255, 0.75)"
                : "rgba(30, 41, 59, 0.75)",
        border: "none",
        borderRadius: "12px",
        cursor: "pointer",
        transition: "all 0.3s ease",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "15px",
        fontWeight: "700",
    }),

    requestItem: {
        background:
            theme === "dark" ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.03)",
        border:
            theme === "dark"
                ? "2px solid rgba(255, 255, 255, 0.12)"
                : "2px solid rgba(0, 0, 0, 0.08)",
        borderRadius: "20px",
        padding: "24px",
        display: "flex",
        alignItems: "center",
        gap: "20px",
        marginBottom: "16px",
        transition: "all 0.3s ease",
    },

    requestIcon: (status) => ({
        width: "56px",
        height: "56px",
        background: `${getStatusColor(status)}25`,
        borderRadius: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    }),

    requestContent: {
        flex: 1,
    },

    requestTitle: {
        fontSize: "18px",
        fontWeight: "800",
        color: theme === "dark" ? "#fff" : "#1e293b",
        margin: "0 0 8px 0",
        textAlign: isRTL ? "right" : "left",
    },

    requestMeta: {
        fontSize: "14px",
        color:
            theme === "dark" ? "rgba(255, 255, 255, 0.7)" : "rgba(30, 41, 59, 0.7)",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        flexWrap: "wrap",
    },

    urgencyBadge: (urgency, getUrgencyColor) => ({
        padding: "6px 12px",
        background: `${getUrgencyColor(urgency)}25`,
        color: getUrgencyColor(urgency),
        borderRadius: "10px",
        fontSize: "13px",
        fontWeight: "800",
        textTransform: "capitalize",
    }),

    documentTypeCard: (isSelected) => ({
        padding: "24px",
        border: `3px solid ${isSelected
                ? "#3b82f6"
                : theme === "dark"
                    ? "rgba(255, 255, 255, 0.12)"
                    : "rgba(0, 0, 0, 0.1)"
            }`,
        borderRadius: "20px",
        marginBottom: "20px",
        cursor: "pointer",
        background: isSelected
            ? "rgba(59, 130, 246, 0.12)"
            : theme === "dark"
                ? "rgba(255, 255, 255, 0.03)"
                : "rgba(0, 0, 0, 0.02)",
        display: "flex",
        alignItems: "flex-start",
        gap: "20px",
        transition: "all 0.3s ease",
        boxShadow: "none",
    }),

    documentTypeIcon: (isSelected) => ({
        width: "56px",
        height: "56px",
        background: isSelected
            ? "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)"
            : theme === "dark"
                ? "rgba(255, 255, 255, 0.12)"
                : "rgba(0, 0, 0, 0.06)",
        borderRadius: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        boxShadow: "none",
    }),

    documentTypeContent: {
        flex: 1,
    },

    documentTypeName: {
        fontSize: "18px",
        fontWeight: "800",
        color: theme === "dark" ? "#fff" : "#1e293b",
        margin: "0 0 8px 0",
        textAlign: isRTL ? "right" : "left",
    },

    documentTypeDescription: {
        fontSize: "15px",
        color:
            theme === "dark" ? "rgba(255, 255, 255, 0.7)" : "rgba(30, 41, 59, 0.7)",
        lineHeight: 1.6,
        textAlign: isRTL ? "right" : "left",
    },

    repaymentPlanBox: {
        background:
            theme === "dark"
                ? "linear-gradient(145deg, rgba(59, 130, 246, 0.15) 0%, rgba(37, 99, 235, 0.1) 100%)"
                : "linear-gradient(145deg, rgba(59, 130, 246, 0.08) 0%, rgba(59, 130, 246, 0.05) 100%)",
        border: `2px solid ${theme === "dark" ? "rgba(59, 130, 246, 0.4)" : "rgba(59, 130, 246, 0.3)"
            }`,
        borderRadius: "16px",
        padding: "24px",
        marginBottom: "28px",
        boxShadow:
            theme === "dark"
                ? "0 8px 24px rgba(0, 0, 0, 0.3), 0 4px 12px rgba(59, 130, 246, 0.2)"
                : "0 8px 24px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(59, 130, 246, 0.1)",
    },

    repaymentPlanHeader: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        marginBottom: "14px",
    },

    repaymentPlanTitle: {
        fontSize: "17px",
        fontWeight: "800",
        color: theme === "dark" ? "#fff" : "#1e293b",
    },

    repaymentPlanText: {
        fontSize: "15px",
        color:
            theme === "dark"
                ? "rgba(255, 255, 255, 0.85)"
                : "rgba(30, 41, 59, 0.85)",
        lineHeight: 1.7,
    },
});
